import { HttpInterceptor, HttpRequest, HttpHandler, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';

import { createProviderToken, provide } from '@recruitee/common';

interface RequestHeader {
  name: string;
  value: string | string[];
}

/**
 * Runs in injection context
 */
export type HeadersFactoryFn = () => RequestHeader;

export const { provide: provideRequestHeader, inject: injectRequestHeaders } =
  createProviderToken<HeadersFactoryFn>('request header factory')(true);

@Injectable()
export class RequestHeadersInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler) {
    const headersFactory = injectRequestHeaders();
    const setHeaders = headersFactory.reduce((acc, factory) => {
      const { name, value } = factory();
      return { ...acc, [name]: value };
    }, {});

    const modifiedReq = req.clone({ setHeaders });
    return next.handle(modifiedReq);
  }
}

export const provideHeadersInterceptor = provide(
  <InjectionToken<HttpInterceptor>>HTTP_INTERCEPTORS,
  { useClass: RequestHeadersInterceptor, multi: true },
);
